import Tab from "components/Tab";
import SnippetInstructions from "../../../../contents/docs/integrate/_snippets/install-js-snippet.mdx";
import SDKs from "../../../../contents/docs/integrate/_snippets/sdks.mdx";
import Frameworks from "../../../../contents/docs/integrate/_snippets/frameworks.mdx";
import API from "../../../../contents/docs/integrate/_snippets/api.mdx";
import Wizard from "../../../../contents/docs/getting-started/_snippets/wizard.mdx";
import * as React from 'react';
export default {
  Tab,
  SnippetInstructions,
  SDKs,
  Frameworks,
  API,
  Wizard,
  React
};